/* naawm / Nox — curseur avant/après (~0,3 Ko) */
(function () {
  if (window.__noxBa) return;
  window.__noxBa = true;

  function init() {
    document.querySelectorAll('[data-nox-ba]:not(.nox-ba-done)').forEach(function (el) {
      el.classList.add('nox-ba-done');
      var frame = el.querySelector('.nox-ba__frame');
      var range = el.querySelector('.nox-ba__range');
      if (!frame || !range) return;

      function setPos(v) {
        v = Math.max(0, Math.min(100, v));
        el.style.setProperty('--ba-pos', v + '%');
        el.style.setProperty('--ba-p', v / 100);
        range.value = v;
      }

      /* Glissement direct sur l'image (souris + tactile) */
      /* Le drag natif de l'image (fantôme macOS) annule le suivi du pointeur */
      frame.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
      var dragging = false;
      function fromEvent(e) {
        var r = frame.getBoundingClientRect();
        setPos(((e.clientX - r.left) / r.width) * 100);
      }
      frame.addEventListener('pointerdown', function (e) {
        dragging = true;
        frame.setPointerCapture(e.pointerId);
        fromEvent(e);
      });
      frame.addEventListener('pointermove', function (e) {
        if (dragging) fromEvent(e);
      });
      frame.addEventListener('pointerup', function () {
        dragging = false;
      });
      frame.addEventListener('pointercancel', function () {
        dragging = false;
      });

      /* Clavier (accessibilité) via le range */
      range.addEventListener('input', function () {
        setPos(parseFloat(range.value));
      });
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
